<template>
    <div>
        <b-row class="btn-bottom-marging">
            <b-col cols="12">
                <b-button size="sm" variant="success" class="btn btn-success pull-right"  v-if="$can('Create_user', 'all')">
                    <router-link to="/users/create" style="color: #fff !important">
                      <i class="fa fa-plus"></i> Create User
                   </router-link>
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

.search-panel-btn {
  float: right;
}

.btn-bottom-marging {
    margin-bottom: 10px;
}

</style>